$(document).ready( function () {
    // Show either new contact section of select existing section domain_registration.tpl
    $('.group').hide()
    $('#existing').show()
    $('.section-toggle').on('change', function () {
        $('.group').hide()
        $('#' + $(this).val()).show()
    })
    $('table').each(function() {
        if($(this).height() > window.innerHeight - 200) $(this).stickyTableHeaders();
    })
});

if ($('.btn.add_domain').length) {
    let new_domain_entry = "<div class=\"domain_entry\"><input name=\"domains_to_add[]\" type=\"text\" class='domain_name'> <button class=\"btn domain_btn add_domain\" name=\"add_domain\" type=\"button\"></button><button class=\"btn domain_btn remove_domain\" name=\"remove_domain\" type=\"button\"></button></div>"

    $(document).on('click', 'button.add_domain', function () {
        let domain_input = $(this).parent().children('input');
        let remove_btn = $(this).parent().children('button.remove_domain');

        if (domain_input.val().trim() === '') {
            $(this).parent().append("<i class=\"fa-solid fa-circle-exclamation\"></i><div class='error_message'><p>Required Field</p></div>")
            return;
        } else if (domain_input.val().trim() !== '' && $(this).parent().children('input').hasClass('invalid')) {
            $(this).parent().children('i, div.error_message').remove();
        }

        $(this).parent().parent().find('i, div.error_message').remove();

        $(this).hide();
        remove_btn.show();
        domain_input.prop('readonly', (i, v) => !v);

        $('.row.domain_names label').append(new_domain_entry);
    });

    // TODO: Make it an in-form error message. Not an alert
    // $(document).on('click', 'button.remove_domain', function () {
    //     $(this).parent().remove();
    // });
}

$(document).on('click', 'div button.next_page', function () {

    if ($('.domain_entry').length === 1 && $('.domain_entry').children('input.domain_name').val().trim() === '') {
        let domain_input = $(this).parent().find('input');

        domain_input.parent().append("<i class=\"fa-solid fa-circle-exclamation\"></i><div class='error_message'><p>Required Field</p></div>")
        return;
    }

    $(this).parent().children().find('input:visible').each(function () {
        if ($(this).val().trim() === '' && !$(this).hasClass('optional') && !$(this).hasClass('domain_name')
            && !$(this).hasClass('contact_id') && !$(this).hasClass('name')
            && !$(this).nextAll('div.error_message').length) {
            $(this).parent().append("<i class=\"fa-solid fa-circle-exclamation\"></i><div class='error_message'><p>Required Field.</p></div>");
        } else if ($(this).val().trim() !== '' && $(this).hasClass('domain_name')) {
            // let domain_input = $(this).parent().find('input.domain_name:last').parent();

            $(this).prop('readonly', (i, v) => !v);
            $(this).parent().children('.add_domain').remove();
            $(this).parent().children('.remove_domain').show();
        }
    });

    if ($(this).parent('.form-page').find('div.error_message').length > 0) {
        return;
    }

    let next_page = $(this).closest('.form-page').next();
    let prev_page = $(this).closest('.form').find('.form-page:visible');

    next_page.show();
    prev_page.hide();
    nextStep();
});

$(document).on('click', 'div.form-page input', function () {
    if ($(this).nextAll('div.error_message').length > 0) {
        $(this).nextAll('div.error_message, i').remove();
    }
});

// $(document).on('click', 'div button.next_page', function () {
//     console.log($(this).parent())
//
//     if ($('.domain_entry').length === 1 && $('.domain_entry').children('input.domain_name').val().trim() !== '') {
//         let domain_input = $(this).parent().find('input');
//
//         console.log('hi')
//
//         domain_input.parent().append("<i class=\"fa-solid fa-circle-exclamation\"></i><div class='error_message'><p>Required Field</p></div>")
//         return;
//     } else {
//         let domain_input = $(this).parent().find('input.domain_name:last').parent();
//
//         domain_input.remove();
//     }
//
//     $(this).parent().children().find('input:visible').each(function () {
//         if ($(this).val().trim() === '' && !$(this).hasClass('optional') && !$(this).hasClass('domain_name')
//             && !$(this).hasClass('contact_id') && !$(this).hasClass('name')
//             && !$(this).nextAll('div.error_message').length) {
//             $(this).parent().append("<i class=\"fa-solid fa-circle-exclamation\"></i><div class='error_message'><p>Required Field.</p></div>");
//         }
//     });
//
//     if ($(this).parent('.form-page').find('div.error_message').length > 0) {
//         return;
//     }
//
//     let next_page = $(this).closest('.form-page').next();
//     let prev_page = $(this).closest('.form').find('.form-page:visible');
//
//     next_page.show();
//     prev_page.hide();
//     nextStep();
// });

$(document).on('click', 'div button.prev_page', function () {
    let curr_page = $(this).closest('.form-page');
    let prev_page = $(this).closest('.form-page').prev();

//         let domain_input = $(this).parent().find('input.domain_name:last').parent();

    if (prev_page.children('div.row').hasClass('domain_names') && prev_page.children('div.row').find('input.domain_name:last').val() !== '') {
        let new_domain_entry = "<div class=\"domain_entry\"><input name=\"domains_to_add[]\" type=\"text\" class='domain_name'> <button class=\"btn domain_btn add_domain\" name=\"add_domain\" type=\"button\"></button><button class=\"btn domain_btn remove_domain\" name=\"remove_domain\" type=\"button\"></button></div>";

        prev_page.find('label').append(new_domain_entry);
    }

    curr_page.hide();
    prev_page.show();
    prevStep();
});

function nextStep() {
    $('.step').each(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).addClass('finish');
        }
    });

    $('.steps').find('.step.inactive:first').addClass('active');
    $('.steps').find('.step.inactive:first').removeClass('inactive');
}

function prevStep() {
    $('.step').each(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).addClass('inactive');
        }
    });

    $('.steps').find('.step.finish:last').addClass('active');
    $('.steps').find('.step.finish:last').removeClass('finish');
}

$(document).on('change', '.create_contact_section input.name', function () {
    let value = $(this).val();
    let group = $(this).closest('.contact_section').children('.container').children('.group');

    let id = value.substring(0, value.indexOf(' '));

    if (value !== '0 - Create new contact') {
        group.hide();

        group.find('div.error_message, i').remove();
        $(this).closest('label').children('input.contact_id').attr('value', id);
        group.find('input:not(.optional)').removeAttr('required', true);
    } else {
        group.show();

        group.find('div.error_message, i').remove();
        $(this).closest('label').children('input.contact_id').attr('value', '');
        group.find('input:not(.optional)').attr('required', true);
    }
});

$(document).on('change', '#dns_template', function () {
    if($(this).val() != 0) {
        $('.dns_custom').hide();
    } else {
        $('.dns_custom').show();
    }
});

$(document).on('change', '.contact_section select[name=tech_contact], .contact_section select[name=admin_contact]', function () {
    let value = $(this).val();
    let group = $(this).closest('.contact_section').children('.group');
    let presetTls = $('.dns_preset.tls');
    let presetGummybear = $('.dns_preset.gummybear');

    let id = value.substring(0, value.indexOf(' '));

    if (value != 0) {
        group.hide();

        // Pre-select custom DNS records
        if(value == 129961) { // Gummy Bear
            $(presetTls).hide();
            $(presetTls).find('input, select, textarea').prop('disabled', true);

            $(presetGummybear).show();
            $(presetGummybear).find('input, select, textarea').prop('disabled', false);
        } else {
            // The Logic Studio and others
            $(presetTls).show();
            $(presetTls).find('input, select, textarea').prop('disabled', false);

            $(presetGummybear).hide();
            $(presetGummybear).find('input, select, textarea').prop('disabled', true);
        }

        group.find('div.error_message, i').remove();
        $(this).closest('label').children('input.contact_id').attr('value', id);
        group.find('input:not(.optional)').removeAttr('required', true);
    } else {
        group.show();

        group.find('div.error_message, i').remove();
        $(this).closest('label').children('input.contact_id').attr('value', '');
        group.find('input:not(.optional)').attr('required', true);
    }
});
$('.contact_section select[name=tech_contact]').trigger('change');

$('code.copy').each(function () {
    let text = $(this).text(),
        $button = $('<a href="#">📋</a>').on('click', function (event) {
            event.preventDefault()
            copyTextToClipboard(text)
        })
    $(this).after($button)
})

function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text)
        return
    }
    return navigator.clipboard.writeText(text)
}

function fallbackCopyTextToClipboard(text) {
    $("<textarea>")
        .text(text)
        .appendTo('body')
        .trigger('focus')
        .trigger('select');

    document.execCommand('copy')
    $textArea.remove()
}

$('.user-select').selectpicker({
    liveSearch: true
});

// Replace do not renew row inputs with warning
// Highlight any renewals that are set for 1 year
$('.renewal_period').on('change', function () {
    let tablerow = $(this).parent().parent()
    if ($(this).val() == 0) {
        tablerow.children().each(function () {
            $(this).find('input').css('display', 'none');
            $(this).find('input.name').removeAttr('required')
            tablerow.css('background', '#f8d7da')
        });
    } else if ($(this).val() == 1) {
        tablerow.css('background', '#fff3cd')
    } else {
        tablerow.children().each(function () {
            $(this).find('input').css('display', 'block');
            $(this).find('input.name').attr('required', true);
            tablerow.css('background', 'none')
        });
    }
});

$('.quickfilter').each(function () {
    let $input = $(this);
    let $targ = $($input.data('target')).children().not('button,.button,thead,tfoot');
    let selector = $input.data('selector') ? $input.data('selector') : '> *';
    let $techContact = $('input[name=techContact]');

    function doCombinedFilter() {
        $targ.show();
        let filter = $input.val().toLowerCase().replace(/([A-Za-z])&([A-Za-z])/g, '$1 & $2'),
            filter2 = filter.replace(/([A-Za-z]) & ([A-Za-z])/g, '$1&$2');

        $targ.each(function () {
            let $el = $(this);
            let content = $el.find(selector).text().replace(/\(.*\)/g, '').toLowerCase();
            let textMatches = !filter || content.match(filter) || content.match(filter2);
            let techContactChecked = $techContact.is(':checked');
            let techId = $el.data('tech-id');
            let techContactMatches = !(techContactChecked && techId === 99798);

            if (!(textMatches && techContactMatches)) {
                $el.hide();
            }
        });
    }

    $input.on('change input', doCombinedFilter);
    $techContact.on('change', doCombinedFilter);

    doCombinedFilter(); // initial run
});

//Add new row to DNS table
$('#new-record').on('click', function (event) {
    event.preventDefault()
    $(this).prop('disabled', true);
    let row = $('#dns-table tbody>tr:last').clone(true),
        btn = row.find('button'),
        last = row.find('td:last')

    $('#dns-table tbody').append(row)
    row.find('input, select').val('')
    row.find('input.record_prefix').attr('name', 'new_record_prefix')
    row.find('select.record-type').attr('name', 'new_record_type').trigger('change')
    row.find('input.record-prio').attr('name', 'new_record_prio')
    row.find('input.record-address').attr('name', 'new_record_address')

    btn.remove()
    last.append('<button class="btn btn-outline-success" id="save-dns-record" name="save-record" type="submit">Add</button>')
});

//Set alert on delete button for DNS records
$('.delete').on('click', function (event) {
    if (!confirm("Are you sure you want to delete this DNS record?")) {
        event.preventDefault()
        return false;
    }
    if (!$(this).val()) {
        let row = $('#dns-table tbody>tr:last').remove()
    }
})

$('contact-list').on('input', function () {
    let selectedOption = this.list.options[this.selectedIndex]
})

$('.record-type').on('change', function () {
    var $priority = $(this).closest('tr').find('.record-prio')
    if ($(this).val() == 'MX' || $(this).val() == 'SRV') {
        $priority.show()
    } else {
        $priority.hide()
    }
}).trigger('change');

/* Calculate Domain totals */
if($('#domain-invoices').length) {
    calculateInvoiceTotals();
}

function calculateInvoiceTotals() {
    const $table = $('#domain-invoices');
    $table.find('tbody tr').each(function () {
        updateInvoiceRowTotal($(this));
    });
}

function updateInvoiceRowTotal($row) {
    let totalInput = $row.find('input[name^="domain["][name$="[total_cost]"]');
    let costPerYear = parseFloat($row.find('input[name^="domain["][name$="[cost_per_year]"]').val());
    let ratePerYear = parseFloat($row.find('input[name^="domain["][name$="[default_rate]"]').val());
    let specialRate = parseFloat($row.find('input[name^="domain["][name$="[rate]"]').val());
    let years = parseInt($row.find('select[name^="domain["][name$="[years]"]').val());
    let total = 0;

    if(specialRate) {
        total = specialRate*years;
    } else {
        total = ratePerYear*years;
    }

    if(total && years) {
        totalInput.val(total.toFixed(2));
    }
}

$(document).on('input change', '#domain-invoices tbody tr input, #domain-invoices tbody tr select', function () {
    const $row = $(this).closest('tr');
    updateInvoiceRowTotal($row);
});

$('#checkDomain').on('click', function (e) {
    // e.preventDefault();
    let $form = $(this).closest('form');
    let domain = $form.find('input[name=new_domain]').val();
    $('.invalid-dom').removeClass('show');

    // Check if domain is valid
    if(domain) {
        $.ajax({
            url: "/ajax/check_domain",
            type: "POST",
            data: {
                domain: domain
            },
            error: function (e) {
                console.log('error ' + e)
            },
            success: function (data) {
                if(data.available) {
                    let $domEl = $('.domain_entry');
                    if(!$domEl.find('input').val()) {
                        $domEl.find('input').val(domain);
                        $domEl.find('.dom_price').html(`$${data.price.DomainPrice.toFixed(2)}`);
                        $('.domain_names').removeClass('d-none');
                    } else {
                        $clone = $domEl.clone();
                        $domEl.parent().append($clone);
                        $clone.find('input').val(domain);
                        $clone.find('.dom_price').html(`$${data.price.DomainPrice.toFixed(2)}`);
                    }
                } else {
                    $('.invalid-dom').addClass('show');
                }

                // updateDomainList();
            }
        });
    }
});

$('.add_record').on('click', function (e) {
    let $lastEl = $('.domain_registration_verification .dom_record:last');
    if($lastEl.find('input[name="record_value[]"]').val()) {
        $clone = $lastEl.clone();
        $clone.find('input[name="record_name[]"').val('');
        $clone.find('input[name="record_value[]"').val('');
        $clone.insertAfter($lastEl)
    }
})

$(document).on('click', '.remove_record', function (e) {
    let $recordEl = $(this).closest('.dom_record')
    if($('.dom_record').length > 1) {
        $recordEl.remove();
    } else {
        $recordEl.find('input[name="record_name[]"').val('');
        $recordEl.find('input[name="record_value[]"').val('');
    }
})

/*function updateDomainList() {
    if(validDomains.length) {
        let listEl = $('#validDomains');

        let listRaw = ``;
        validDomains.forEach(function (item) {
           listRaw += `<p>` + item.domain + ` ($` + item.price + `)</p>`
        });
        listEl.html(`<h3>The following domains are available:</h3>` + listRaw);

        listEl.removeClass('d-none');
    }

    if(invalidDomains.length) {
        let listEl = $('#invalidDomains');

        let listRaw = ``;
        invalidDomains.forEach(function (item) {
            listRaw += `<p>` + item.domain + `</p>`
        });
        listEl.html(`<h3>The following domains are unavailable:</h3>` + listRaw);

        listEl.removeClass('d-none');
    }
}*/

$('#domainModal').on('show.bs.modal', function () {
    // Fill data
    let $form = $('form[name=domains]');
    let $domainEls = $form.find('.domains input[type=checkbox]:checked');
    let $usersEl = $form.find('.user-select');

    // Domains
    if($domainEls.length) {
        let domains = `<ul>`;
        $domainEls.each(function () {
            const name = $(this).attr('name');
            const match = name.match(/^domain\[(.*?)\]/);
            if (match && match[1]) {
                // domains.push(match[1]);
                domains += `<li>${match[1]}</li>`;
            }
        });
        domains += '</ul>';
        $(this).find('.domains').html(domains);
    }

    if($form.find('input#let_expire:checked').length) {
        $(this).find('.expiry').show();
    } else {
        $(this).find('.expiry').hide();
    }

    // Reason
    let reason = $('textarea[name=expire_reason]').val();
    if(reason) {
        $(this).find('.reason').html(`<p><em>"${reason}"</em></p>`);
    }

    // Users
    let userids = $usersEl.selectpicker('val');
    let selectedTexts = [];
    selectedOptions = $usersEl.find('option:selected');
    if(selectedOptions.length) {
        let users = `<ul>`;
        selectedOptions.each(function () {
            users += `<li>` + $(this).text() + `</li>`
        })
        users += `</ul>`;

        $(this).find('.userList').html(users);
    }

    $('#submitDomainChanges').on('click', function (e) {
        $(this).modal('hide');
        $form.submit();
    })
});

$('#let_expire').on('change', function (e) {
    if($(this).is(':checked')) {
        $('.expire_reason_wrapper').removeClass('d-none');
    } else {
        $('.expire_reason_wrapper').addClass('d-none');
    }
});

$(document).on('click', 'button.remove_domain', function () {
    let $domEls = $('.domain_entry');
    if($domEls.length == 1) {
        $domEls.find('input').val('');
        $domEls.closest('.domain_names').addClass('d-none');
    } else {
        $(this).closest('.domain_entry').remove();
    }
});

$('.open-reg-modal').on('click', function (e) {
    let $form = $('form.domain_registration_verification');
    $form.validate();

    let domains = false;
    $form.find('.domain_entry input.domain_name').each(function () {
        if($(this).val()) domains = true;
    });

    if ($form.valid() && domains) {
        $('#domainRegModal').modal('show'); // Only show modal if form is valid
    } else if (!domains) {
        alert('Please enter at least one domain to register.');
    }
});

$('#domainRegModal').on('show.bs.modal', function () {
    // Fill data
    let $form = $('form.domain_registration_verification');

    // Domains
    let total = 0;
    let domains = `<ul>`;
    $form.find('.domain_entry input.domain_name').each(function () {
        let price = $(this).parent().find('.dom_price').html();
        domains += `<li>` + $(this).val() + ` -- ` + price + `</li>`
        total += parseFloat(price.replace('$', ''));
    });
    domains += '</ul>';
    $(this).find('.domains').html(domains);

    // Registrant
    if($('select[name=admin_contact]').val() != 0) {
        $(this).find('.contact').html(`<strong>` + $('select[name=admin_contact] option:selected').text() + `</strong>`);
    } else {
        $(this).find('.contact').html(`<strong>` + $('input[name=name]').val() + ' (' + $('input[name=email]').val() + `)</strong>`);
    }

    // Technical Contact
    if($('select[name=tech_contact]').val() != 0) {
        $(this).find('.tech_contact').html(`<strong>` + $('select[name=tech_contact] option:selected').text() + `</strong>`);
    } else {
        $(this).find('.tech_contact').html(`<strong>` + $('input[name=tech_name]').val() + ' (' + $('input[name=tech_email]').val() + `)</strong>`);
    }

    // Period
    $(this).find('.period').html($('select.registration-period option:selected').text());

    // Total
    $(this).find('.totalPrice').html(`$${(total * 1.15).toFixed(2)}`)

    $('#submitDomainRegistration').on('click', function (e) {
        $(this).modal('hide');
        $form.submit();
    })
});